// mds-dojo — dojo/touch — pragmatic port. Real dojo/touch normalizes touch/pointer/
// mouse into synthetic press/move/release/over/out/enter/leave/cancel/tap extension
// events. Under modern evergreen browsers (the migration target) Pointer Events
// unify mouse+touch, so we map each synthetic name to the appropriate native event
// (or a dojo/mouse synthetic for enter/leave). This is the surface _AttachMixin's
// synthEvents table + any `on(node, touch.press, fn)` call needs.
import on from './on';
import mouse from './mouse';

const hasPointer = typeof window !== 'undefined' && 'PointerEvent' in window;
const hasTouch = typeof window !== 'undefined' && ('ontouchstart' in window);

// Build an extension-event function for a given native event name.
function ee(nativeType: string): any {
  const fn: any = function (node: any, listener: any) {
    return on(node, nativeType, listener);
  };
  fn.eventName = nativeType;
  return fn;
}

const press = hasPointer ? ee('pointerdown') : (hasTouch ? ee('touchstart') : ee('mousedown'));
const move = hasPointer ? ee('pointermove') : (hasTouch ? ee('touchmove') : ee('mousemove'));
const release = hasPointer ? ee('pointerup') : (hasTouch ? ee('touchend') : ee('mouseup'));
const cancel = hasPointer ? ee('pointercancel') : (hasTouch ? ee('touchcancel') : ee('mouseleave'));
const over = hasPointer ? ee('pointerover') : ee('mouseover');
const out = hasPointer ? ee('pointerout') : ee('mouseout');

const touch: any = {
  press: press,
  move: move,
  release: release,
  cancel: cancel,
  over: over,
  out: out,
  enter: mouse.enter,
  leave: mouse.leave,
  // tap: a click is the accessible, evergreen-safe equivalent
  tap: ee('click'),
};

export default touch;
